module.exports = __webpack_public_path__ + "static/media/family-child-benefit.f6ca0cb7.svg";